import React from 'react';

// Options for size: 'sm', 'md', 'lg'
// Options for variant: 'primary', 'secondary', 'light', 'dark'
const Loader = ({ 
  size = 'md', 
  variant = 'primary', 
  fullScreen = false,
  text = '',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6 border-2',
    md: 'w-8 h-8 border-2',
    lg: 'w-12 h-12 border-3',
    xl: 'w-16 h-16 border-4'
  };

  const variantClasses = {
    primary: 'border-blue-600 border-t-transparent',
    secondary: 'border-gray-600 border-t-transparent',
    light: 'border-white border-t-transparent',
    dark: 'border-gray-800 border-t-transparent',
    success: 'border-green-500 border-t-transparent',
    danger: 'border-red-600 border-t-transparent',
    warning: 'border-yellow-500 border-t-transparent'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;
  const variantClass = variantClasses[variant] || variantClasses.primary;

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-75">
        <div className={`animate-spin rounded-full ${sizeClass} ${variantClass} ${className}`}></div>
        {text && <p className="mt-4 text-gray-700 dark:text-gray-300">{text}</p>}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center">
      <div className={`animate-spin rounded-full ${sizeClass} ${variantClass} ${className}`}></div>
      {text && <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">{text}</p>}
    </div>
  );
};

export default Loader; 
